import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onLoaderTrigger } from "redux/actions/commonAction";
import { ACCOUNT_DELETION } from "resources/actionTypes";
import store from "redux/store";
import { accountDeletionApi } from "services/accountDeletionService";

function* accountDeletionListener(action) {
    const payload = action.payload || {};
    store.dispatch(onLoaderTrigger(true));
    const userDetails = yield call(accountDeletionApi, payload?.userDetails);

    if (userDetails.success) {
      yield put({ type: ACCOUNT_DELETION.ACCOUNT_DELETION_SUCCESS, userDetails: userDetails });
      payload?.closeAction(true);
      payload?.resetForm();
      store.dispatch(onLoaderTrigger(false));
    } else {
      yield put({ type: ACCOUNT_DELETION.ACCOUNT_DELETION_FAILED, message: userDetails.message });
        toast.error(userDetails.message || "Account Deletion Failed");
        store.dispatch(onLoaderTrigger(false));
    }
  }
  
  export function* accountDeletionSaga() {
    yield takeEvery(ACCOUNT_DELETION.ACCOUNT_DELETION_REQUESTED, accountDeletionListener);
  }